import { Button, Container, Grid, Typography } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import signOut from "../../constants/images/signOut_red.png";
import * as ROUTES from "../../constants/routes";

const SignOut = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <Container>
      <Grid
        container
        style={{
          textAlign: "center",
        }}
        alignItems="center"
        justify="center"
        direction="column"
      >
        <Grid item xs={12} md={7} lg={8}>
          <Typography
            variant="h5"
            color="textSecondary"
            style={{
              justifySelf: "center",
              marginTop: 64,
              fontWeight: 200,
              fontSize: "1.9rem",
            }}
          >
            {t("signOutToViewForm")}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6} lg={5} style={{ alignContent: "center", marginTop: "5vh" }}>
          <img src={signOut} style={{ width: "100%" }} />
          <Button
            variant="outlined"
            color="primary"
            style={{ marginTop: 32 }}
            onClick={() => {
              history.push(ROUTES.HOME);
            }}
          >
            {t("home")}
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};

export default SignOut;
